import React, {Component, ReactElement, RefObject} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {HKConstants} from '../../../HKConstants'
import NatResidentUserRepo from '../residentUser/repository/NatResidentUserRepo'
import {NatGetResidentUserAuthed} from '../residentUser/repository/NatGetResidentUserAuthed'
import {Accordion, AccordionDetails, AccordionSummary, Box, Typography} from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import styled from 'styled-components'
import {Messages} from '../../../Messages'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {NatAsyncCallFunction} from '../../common/util/Natutil'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {SmallPlainLinkStyledButton} from '../../../styledComponents/Button'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {currentMedia} from '../../../styledComponents/ResponsiveConvenience'
import {PageTitle} from '../applications/common/resident/NatResidentApplicationsCommon'
import {Phone} from '@mui/icons-material'
import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {Location} from 'react-router-dom'

const KEY_SELECTED_CONDOMINIUM_NAME: string = 'selectedCondominiumName'
const KEY_SELECTED_CONDOMINIUM_ZIP_CODE: string = 'selectedCondominiumZipCode'
const KEY_SELECTED_CONDOMINIUM_ADDRESS_PREFECTURE: string = 'selectedCondominiumAddressPrefecture'
const KEY_SELECTED_CONDOMINIUM_ADDRESS_ADDRESS2: string = 'selectedCondominiumAddressAddress2'
const KEY_SELECTED_CONDOMINIUM_ADDRESS_ADDRESS3: string = 'selectedCondominiumAddressAddress3'
const KEY_LOGIN_USER_MAIL_ADDRESS_DOMAIN: string = 'loginUserMailAddressDomain'

const PARAMETER_FAMILY_NAME: string = 'f000916257'
const PARAMETER_FIRST_NAME: string = 'f000916259'
const PARAMETER_CONDOMINIUM_NAME: string = 'f000916264'
const PARAMETER_ZIP_CODE: string = 'f000916261'
const PARAMETER_PREFECTURES: string = 'f000916262'
const PARAMETER_ADDRESS: string = 'f000916263'
const PARAMETER_FAMILY_NAME_KANA: string = 'f000916258'
const PARAMETER_FIRST_NAME_KANA: string = 'f000916260'
const PARAMETER_MAIL_ADDRESS: string = 'f000916266'

interface Props {
    residentUserRepo: NatResidentUserRepo,
    location: Location
}

interface States {
    familyName: string,
    firstName: string,
    condominiumName: string,
    zipCodeFirst: string,
    zipCodeLatter: string,
    prefectures: string,
    address: string,
    familyNameKana: string,
    firstNameKana: string,
    mailAddress: string,
}

class NatResidentContactusPage extends Component<Props & ResidentPagePropsSet, States> {
    submit: RefObject<HTMLFormElement>

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)

        this.state = {
            familyName: ``,
            firstName: ``,
            condominiumName: ``,
            zipCodeFirst: ``,
            zipCodeLatter: ``,
            prefectures: ``,
            address: ``,
            familyNameKana: ``,
            firstNameKana: ``,
            mailAddress: ``,
        }
        this.submit = React.createRef()

        this.contactusApartLinkClick = this.contactusApartLinkClick.bind(this)
        this.contactusLinkClick = this.contactusLinkClick.bind(this)
        this.renderSutekiContactus = this.renderSutekiContactus.bind(this)
    }

    async componentDidMount(): Promise<void> {
        if (SessionStorageHelper.getStringItemOrNull('AUTHORITIES')) {
            await this.props.eventEmitter.showLoading()
            try {
                // ユーザ情報取得
                const retResidentUser: Nullable<NatGetResidentUserAuthed> = await NatAsyncCallFunction(
                    this.props.residentUserRepo.getResidentUserLogined.bind(
                        this.props.residentUserRepo), this.props.navigate)

                let condominiumName: Nullable<string> =
                    SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_NAME)
                if (condominiumName === null) {
                    condominiumName = ''
                }

                const zipCode: Nullable<string> =
                    SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_ZIP_CODE)
                let zipCodeFirst: string = ''
                let zipCodeLatter: string = ''
                if (zipCode === null) {
                    zipCodeFirst = ''
                    zipCodeLatter = ''
                } else {
                    zipCodeFirst = zipCode.slice(0, 3)
                    zipCodeLatter = zipCode.slice(-4)
                }

                let prefectures: Nullable<string> =
                    SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_ADDRESS_PREFECTURE)
                if (prefectures === null) {
                    prefectures = ''
                }

                let address = ''
                const address2: Nullable<string> =
                    SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_ADDRESS_ADDRESS2)
                if (address2 !== null) {
                    address = address2
                }
                const address3: Nullable<string> =
                    SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_ADDRESS_ADDRESS3)
                if (address3 !== null) {
                    address += address3
                }

                this.setState({
                        condominiumName: condominiumName,
                        zipCodeFirst: zipCodeFirst,
                        zipCodeLatter: zipCodeLatter,
                        prefectures: prefectures,
                        address: address,
                    },
                )

                if (retResidentUser && retResidentUser.details !== null) {

                    const loginUserMailAddressDomain: string | null =
                        window.sessionStorage.getItem(KEY_LOGIN_USER_MAIL_ADDRESS_DOMAIN)

                    let loginUserMailAddress: string = ''
                    if (loginUserMailAddressDomain) {
                        if (loginUserMailAddressDomain === retResidentUser.details.mailAddressPc.split('@')[1]) {
                            loginUserMailAddress = retResidentUser.details.mailAddressPc
                        } else if (loginUserMailAddressDomain === retResidentUser.details.mailAddressMb.split('@')[1]) {
                            loginUserMailAddress = retResidentUser.details.mailAddressMb
                        }
                    }

                    this.setState({
                            familyName: retResidentUser.details.familyName,
                            firstName: retResidentUser.details.firstName,
                            familyNameKana: retResidentUser.details.familyNameKana,
                            firstNameKana: retResidentUser.details.firstNameKana,
                            mailAddress: loginUserMailAddress,
                        },
                    )
                }
            } finally {
                this.props.eventEmitter.closeLoading()
            }
        }
    }

    // よくある質問 クリック
    faqClick(): void {
        window.open('/resources/contents/faq/residentFaq.pdf', '_blank')
    };

    // お問い合わせ（素敵ネット）
    contactusApartLinkClick(): void {
        window.open(HKConstants.VRS.SYS.CONTACT_WEB_URL_MANSION, '_blank')
    }

    // お問い合わせ（素敵ネット）
    contactusLinkClick(): void {
        if (this.submit.current) {
            this.submit.current.submit()
        }
    }

    // お問い合わせ（ブランシエラクラブ）
    contactusBrancheraLinkClick(): void {
        window.open(HKConstants.VRS.SYS.CONTACT_WEB_URL_BRANCHERA, '_blank')
    }

    // ブランシエラクラブ公式
    officialBrancheraLinkClick(): void {
        window.open(HKConstants.VRS.SYS.OFFICIAL_WEB_URL_BRANCHERA, '_blank')
    }

    // 素敵ネットの操作について
    renderSutekiContactus(): ReactElement {
        return (
            <>
                <Box height={'20px'}/>
                <Box fontSize={FontSize.Middle}>
                    {Messages.IRESR0001.toString()}
                </Box>
                <Box height={'5px'}/>
                <LeftRowFlexContainer>
                    <PhoneIcon fontSize={'large'}/>
                    <Box width={'10px'}/>
                    <Box fontSize={FontSize.Accent} fontWeight={FontWeights.Bold} color={Colors.AccentDark}>
                        {Messages.IRESR0002.toString()}
                    </Box>
                </LeftRowFlexContainer>
                <AlignItemsStartFlexContainer>
                    <Box>受付時間</Box>
                    <Box width={'10px'}/>
                    <Box>{Messages.IRESR0003.toString()}</Box>
                </AlignItemsStartFlexContainer>
                <Box height={'15px'}/>
                <SmallPlainLinkStyledButton onClick={this.contactusLinkClick} type={'button'}>
                    <LeftRowFlexContainer>
                        <FontAwesomeIcon icon={faExternalLinkAlt}/>
                        <Box width={'10px'}/>
                        お問い合わせフォーム
                    </LeftRowFlexContainer>
                </SmallPlainLinkStyledButton>
                <Box height={'5px'}/>
            </>
        )
    }

    // 管理費等ご請求金額の内容について
    renderBillingContactus(): ReactElement {
        return (
            <>
                <Box height={'20px'}/>
                <Box fontSize={FontSize.Middle}>
                    長谷工コンタクトセンター
                </Box>
                <Box height={'5px'}/>
                <LeftRowFlexContainer>
                    <PhoneIcon fontSize={'large'}/>
                    <Box width={'10px'}/>
                    <Box fontSize={FontSize.Accent} fontWeight={FontWeights.Bold} color={Colors.AccentDark}>
                        {Messages.IRESR0007.toString()}
                    </Box>
                </LeftRowFlexContainer>
                <AlignItemsStartFlexContainer>
                    <Box>受付時間</Box>
                    <Box width={'10px'}/>
                    <NewLineContents>{Messages.IRESR0014.toString()}</NewLineContents>
                </AlignItemsStartFlexContainer>
                <Box height={'5px'}/>
            </>
        )
    }

    // 長谷工ID・ブランシエラクラブについて
    renderBrancheraContactus(): ReactElement {
        return (
            <>
                <Box height={'20px'}/>
                <Box fontSize={FontSize.Middle}>
                    ブランシエラクラブ事務局
                </Box>
                <Box height={'5px'}/>
                <LeftRowFlexContainer>
                    <PhoneIcon fontSize={'large'}/>
                    <Box width={'10px'}/>
                    <Box fontSize={FontSize.Accent} fontWeight={FontWeights.Bold} color={Colors.AccentDark}>
                        {Messages.IRESR0013.toString()}
                    </Box>
                </LeftRowFlexContainer>
                <AlignItemsStartFlexContainer>
                    <Box>受付時間</Box>
                    <Box width={'10px'}/>
                    <Box>{Messages.IRESR0003.toString()}</Box>
                </AlignItemsStartFlexContainer>
                <Box height={'15px'}/>
                <SmallPlainLinkStyledButton onClick={this.contactusBrancheraLinkClick} type={'button'}>
                    <LeftRowFlexContainer>
                        <FontAwesomeIcon icon={faExternalLinkAlt}/>
                        <Box width={'10px'}/>
                        お問い合わせフォーム
                    </LeftRowFlexContainer>
                </SmallPlainLinkStyledButton>
                <Box height={'20px'}/>
                <Box fontSize={FontSize.Middle}>
                    長谷工ID・ブランシエラクラブについて知りたい方へ
                </Box>
                <Box height={'5px'}/>
                <SmallPlainLinkStyledButton onClick={this.officialBrancheraLinkClick} type={'button'}>
                    <LeftRowFlexContainer>
                        <FontAwesomeIcon icon={faExternalLinkAlt}/>
                        <Box width={'10px'}/>
                        ブランシエラクラブ公式サイト
                    </LeftRowFlexContainer>
                </SmallPlainLinkStyledButton>
                <Box height={'5px'}/>
            </>
        )
    }

    // マンション管理全般について
    renderMansionContactus(): ReactElement {
        return (
            <>
                <Box height={'20px'}/>
                <Box fontSize={FontSize.Middle}>
                    長谷工コンタクトセンター
                </Box>
                <Box height={'5px'}/>
                <LeftRowFlexContainer>
                    <PhoneIcon fontSize={'large'}/>
                    <Box width={'10px'}/>
                    <Box fontSize={FontSize.Accent} fontWeight={FontWeights.Bold} color={Colors.AccentDark}>
                        {Messages.IRESR0007.toString()}
                    </Box>
                </LeftRowFlexContainer>
                <AlignItemsStartFlexContainer>
                    <Box>受付時間</Box>
                    <Box width={'10px'}/>
                    <NewLineContents>{Messages.IRESR0014.toString()}</NewLineContents>
                </AlignItemsStartFlexContainer>
                <Box height={'15px'}/>
                <SmallPlainLinkStyledButton onClick={this.contactusApartLinkClick} type={'button'}>
                    <LeftRowFlexContainer>
                        <FontAwesomeIcon icon={faExternalLinkAlt}/>
                        <Box width={'10px'}/>
                        お問い合わせフォーム
                    </LeftRowFlexContainer>
                </SmallPlainLinkStyledButton>
                <Box height={'5px'}/>
            </>
        )
    }

    // 水漏れ・夜間の事故など緊急時のお困りごとについて
    renderHelpContactus(): ReactElement {
        return (
            <>
                <Box height={'20px'}/>
                <Box fontSize={FontSize.Middle}>アウル24センター（24時間365日対応）</Box>
                <Box height={'5px'}/>
                <Box
                    fontSize={FontSize.Small}>※ご契約している管理会社によってフリーダイヤルが異なりますのでご注意ください。</Box>
                <Box height={'20px'}/>
                <Box fontSize={FontSize.Middle}>
                    長谷工コミュニティ・長谷工コミュニティ西日本
                </Box>
                <Box height={'5px'}/>
                <LeftRowFlexContainer>
                    <PhoneIcon fontSize={'large'}/>
                    <Box width={'10px'}/>
                    <Box fontSize={FontSize.Accent} fontWeight={FontWeights.Bold} color={Colors.AccentDark}>
                        {Messages.IRESR0015.toString()}
                    </Box>
                </LeftRowFlexContainer>
                <Box height={'15px'}/>
                <Box fontSize={FontSize.Middle}>
                    長谷工コミュニティ九州
                </Box>
                <Box height={'5px'}/>
                <LeftRowFlexContainer>
                    <PhoneIcon fontSize={'large'}/>
                    <Box width={'10px'}/>
                    <Box fontSize={FontSize.Accent} fontWeight={FontWeights.Bold} color={Colors.AccentDark}>
                        {Messages.IRESR0016.toString()}
                    </Box>
                </LeftRowFlexContainer>
                <Box height={'15px'}/>
                <Box fontSize={FontSize.Middle}>
                    長谷工コミュニティ沖縄
                </Box>
                <Box height={'5px'}/>
                <LeftRowFlexContainer>
                    <PhoneIcon fontSize={'large'}/>
                    <Box width={'10px'}/>
                    <Box fontSize={FontSize.Accent} fontWeight={FontWeights.Bold} color={Colors.AccentDark}>
                        {Messages.IRESR0017.toString()}
                    </Box>
                </LeftRowFlexContainer>
                <Box height={'5px'}/>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        return (
            <>
                <form ref={this.submit} action={HKConstants.VRS.SYS.CONTACT_WEB_URL_SUTEKI} method={`post`}
                      target="_blank">
                    <input type={`hidden`} name={PARAMETER_FAMILY_NAME} value={this.state.familyName}/>
                    <input type={`hidden`} name={PARAMETER_FIRST_NAME} value={this.state.firstName}/>
                    <input type={`hidden`} name={PARAMETER_CONDOMINIUM_NAME} value={this.state.condominiumName}/>
                    {(this.state.zipCodeFirst && this.state.zipCodeLatter) ?
                        <input type={`hidden`} name={PARAMETER_ZIP_CODE}
                               value={`${this.state.zipCodeFirst}-${this.state.zipCodeLatter}`}/> : null
                    }
                    <input type={`hidden`} name={PARAMETER_PREFECTURES} value={this.state.prefectures}/>
                    <input type={`hidden`} name={PARAMETER_ADDRESS} value={this.state.address}/>
                    <input type={`hidden`} name={PARAMETER_FAMILY_NAME_KANA} value={this.state.familyNameKana}/>
                    <input type={`hidden`} name={PARAMETER_FIRST_NAME_KANA} value={this.state.firstNameKana}/>
                    <input type={`hidden`} name={PARAMETER_MAIL_ADDRESS} value={this.state.mailAddress}/>
                    <PageTitle>
                        お問い合わせ
                    </PageTitle>
                    <Box height={'20px'}/>
                    <FaqLink onClick={this.faqClick}>
                        よくある質問
                    </FaqLink>
                    を掲載していますので、お問い合わせの際はまずこちらをご確認ください。
                    <Box height={'15px'}/>

                    <StyledSpBox>
                        <StyledExpansionPanel>
                            <StyledExpansionPanelSummary
                                expandIcon={<StyledExpandMoreIcon/>}
                                aria-controls="panel1a-content"
                                id="suteki-contactus-header"
                            >
                                <InfoName>素敵ネットの登録・操作について</InfoName>
                            </StyledExpansionPanelSummary>
                            <StyledExpansionPanelDetails>
                                <StyledTypography>
                                    {this.renderSutekiContactus()}
                                </StyledTypography>
                            </StyledExpansionPanelDetails>
                        </StyledExpansionPanel>
                        <Box height={'2px'}/>
                        <StyledExpansionPanel>
                            <StyledExpansionPanelSummary
                                expandIcon={<StyledExpandMoreIcon/>}
                                aria-controls="panel1a-content"
                                id="billing-contactus-header"
                            >
                                <InfoName>管理費等ご請求金額の内容について</InfoName>
                            </StyledExpansionPanelSummary>
                            <StyledExpansionPanelDetails>
                                <StyledTypography>
                                    {this.renderBillingContactus()}
                                </StyledTypography>
                            </StyledExpansionPanelDetails>
                        </StyledExpansionPanel>
                        <Box height={'2px'}/>
                        <StyledExpansionPanel>
                            <StyledExpansionPanelSummary
                                expandIcon={<StyledExpandMoreIcon/>}
                                aria-controls="panel1a-content"
                                id="branchera-contactus-header"
                            >
                                <InfoName>長谷工ID・ブランシエラクラブについて</InfoName>
                            </StyledExpansionPanelSummary>
                            <StyledExpansionPanelDetails>
                                <StyledTypography>
                                    {this.renderBrancheraContactus()}
                                </StyledTypography>
                            </StyledExpansionPanelDetails>
                        </StyledExpansionPanel>
                        <Box height={'2px'}/>
                        <StyledExpansionPanel>
                            <StyledExpansionPanelSummary
                                expandIcon={<StyledExpandMoreIcon/>}
                                aria-controls="panel1a-content"
                                id="mansion-contactus-header"
                            >
                                <InfoName>マンション管理全般について</InfoName>
                            </StyledExpansionPanelSummary>
                            <StyledExpansionPanelDetails>
                                <StyledTypography>
                                    {this.renderMansionContactus()}
                                </StyledTypography>
                            </StyledExpansionPanelDetails>
                        </StyledExpansionPanel>
                        <Box height={'2px'}/>
                        <StyledExpansionPanel>
                            <StyledExpansionPanelSummary
                                expandIcon={<StyledExpandMoreIcon/>}
                                aria-controls="panel1a-content"
                                id="help-contactus-header"
                            >
                                <InfoName>水漏れ・夜間の事故など緊急時のお困りごとについて</InfoName>
                            </StyledExpansionPanelSummary>
                            <StyledExpansionPanelDetails>
                                <StyledTypography>
                                    {this.renderHelpContactus()}
                                </StyledTypography>
                            </StyledExpansionPanelDetails>
                        </StyledExpansionPanel>
                        <Box height={'2px'}/>
                    </StyledSpBox>
                </form>
            </>
        )
    }
}

export default createResidentPage(NatResidentContactusPage)

const StyledSpBox = styled.div`
  ${currentMedia.lessThan('sp')`
      margin: 0 -15px;
  `};
`

// 枠
const StyledExpansionPanel = withStyles({
        root: {
            margin: '0',
            padding: '15px 15px 15px',
            '&$expanded': {
                margin: '0',
            },
            boxShadow: 'initial',
            '&:before': {
                display: 'none',
            },
        },
        expanded: {},
    })(Accordion)


// タイトル
const StyledExpansionPanelSummary = withStyles({
        root: {
            padding: '0',
            minHeight: '0px',
            '&$expanded': {
                minHeight: '0px',
                margin: '0',
            },
        },
        content: {
            margin: '0',
            '&$expanded': {
                margin: '0',
            },
        },
        expandIcon: {
            marginRight: '0',
            padding: '0',
        },
        expanded: {
            minHeight: '0',
            margin: '0',
        },
    })(AccordionSummary)


// お問い合わせ先情報
const StyledExpansionPanelDetails = withStyles({
        root: {
            padding: '0',
        },
    })(AccordionDetails)


// アコーディオンアイコン
const StyledExpandMoreIcon = withStyles({
        root: {
            fontSize: '2.4rem',
            color: Colors.AccentDark,
        },
    })(ExpandMoreIcon)


// テキストフォント
const StyledTypography = styled(Typography)`
  &.MuiTypography-body1 {
    font-family: 'Noto Sans JP';
    color: ${Colors.Body};
  }
`

const FaqLink = styled.a`
        color: ${Colors.Primary};
        font-Size: ${FontSize.Body};
        line-Height: 24px;
  }
  &:hover {
    cursor: pointer;
  }
`

const AlignItemsStartFlexContainer = styled(LeftRowFlexContainer)`
  align-items: flex-start;
  font-Size: ${FontSize.Small};
`

const NewLineContents = styled.div`
  ${currentMedia.lessThan('sp')`
      white-space:pre;
  `};
`

const InfoName = styled.div`
  flex-grow: 1;
  text-align: start;
  position: relative;
  color: ${Colors.Body};
  margin-right: 15px;
`

const PhoneIcon = withStyles({
        root: {
            color: Colors.Primary,
        },
    })(Phone)

